import { render, staticRenderFns } from "./GruposEmail.vue?vue&type=template&id=a3710f40"
import script from "./GruposEmail.vue?vue&type=script&lang=js"
export * from "./GruposEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports